module.exports = __webpack_public_path__ + "img/1470372652.234c910d.jpg";